// 重构的数据更新
export default {
  // 更新门店的tab
  updateGlobalLoading(state, payload) {
    state.globalLoading = payload
  },
  updateCurrentTab(state, payload) {
    state.currentTab = payload
  },
  updateFilterOptions(state, payload = {}) {
    state.filterOptions = { ...state.filterOptions, ...payload }
  },
  updateFilterValues(state, payload = {}) {
    state.filterValue = { ...state.filterValue, ...payload }
  },
  updateListData(state, { currentTab, result = {} }) {
    const current = state.lists[currentTab]
    state.lists[currentTab] = { ...current, ...result }
  },
  setLoading(state, payload) {
    state.loading = payload
  },
  updateSearchNot(state, payload) {
    state.searchNot = payload
  },
  setOtherPageArrStrategyTagId(state, payload) {
    state.otherPageArrStrategyTagId = payload
  },
  updateFilterSelectNum(state, payload) {
    state.filterSelectNum = payload
  },
  updateGeoErr(state, payload) {
    state.geoErr = payload
  },
  updateStrategyTag(state, payload) {
    state.strategyTagData = payload
  },
  // 更新首页点击的卡片
  updateWorkbenchTagIdsAndCitys(state, payload) {
    // 把获取来的城市数据做映射处理
    const { tagIds, city = [] } = payload
    let cityMap = []
    if (city !== null) {
      cityMap = city.map(item => ({
        label: item.value,
        value: item.key,
      }))
    }
    state.workbenchTagIdsAndCity = {
      tagIds,
      city: cityMap,
    }
  },
  // 获取签约状态的数字
  updateCountByStatus(state, data) {
    state.countByStatus = data
  },
  // 获取加载时间的埋点
  updateTimeStamp(state, payload) {
    state.timestamp = payload
  },
  // 更新电话信息
  updatePhoneInfo(state, payload) {
    state.phoneInfo = payload
  },
  updateCompleteShopIds(state, payload) {
    state.unCompleteShopIds = payload
  },
  updateExpireIdsShopIds(state, payload) {
    state.expireShopIds = payload
  },
  updateNewRsListShopIds(state, payload) {
    state.newRsListShopIds = payload
  },
  updateAllDataPop(state, payload) {
    state.showAllDataPop = payload
  },
  updateStrategyId(state, payload) {
    state.strategyId = payload
  },
  updateSurveySchema(state, payload) {
    state.surveySchema = payload
  },
  updateFirstGetMsgTime(state, payload) {
    state.firstGetMsgTime = payload
  },
  updateSurveyData(state, payload) {
    state.surveyData = payload
  },
  updateSurveyMsgTitle(state, payload) {
    state.surveyMsgTitle = payload
  },
  updateMyStoreTab(state, payload) {
    state.myStoreTab = payload
  },
  // 新店的mystore
  updateMyStoreTabFromNewStore(state, payload) {
    state.myStoreTabFromNewStore = payload
  },
  updateFromNewRsFlag(state, payload) {
    state.isFromNewRsFlag = payload
  },
  updatePromoItem(state, payload) {
    state.promoItem = payload
  },
  // 更新金刚位跳转的页面
  updateAlertSelectJump(state, payload) {
    state.alertSelectJump = payload
  },
}
